import { atom as i } from "jotai";
import { atomWithDefault as g } from "jotai/utils";
import { DEFAULT_CURRENCY as f } from "./index52.mjs";
import { updateExtras as p } from "./index53.mjs";
import { filterExistingCartItems as C } from "./index54.mjs";
const A = i([]), a = g(
  (s) => s(A)
), R = i(
  null,
  (s, o, n) => {
    const t = n[0];
    if (!t)
      return;
    const r = s(a), e = C(
      r,
      t.roomId,
      t.pricingTypeId,
      t.promotionId
    ), c = e.length ? n.map((m) => {
      var u;
      return {
        ...m,
        id: (((u = e[e.length - 1]) == null ? void 0 : u.id) ?? 0) + 1
      };
    }) : n;
    o(a, () => [...e, ...c]);
  }
), b = i(
  null,
  (s, o, n, t, r) => {
    const e = s(a);
    o(
      a,
      C(e, n, t, r)
    );
  }
), G = i(
  null,
  (s, o, n) => {
    const t = s(a), r = t.find((c) => c.id === n);
    if (!r)
      return;
    const e = t.indexOf(r);
    o(
      a,
      t.filter((c, m) => m !== e)
    );
  }
), v = i(null, (s, o) => {
  o(a, []);
}), D = i(
  null,
  (s, o, n, t) => {
    const r = s(a);
    o(
      a,
      r.map((e) => e.id === n ? {
        ...e,
        totalPrice: t
      } : e)
    );
  }
), F = i(f), d = i([]), O = i(""), w = i(
  null,
  (s, o, n) => {
    o(d, (t) => [...t, n]);
  }
), B = i(null, (s, o) => {
  o(d, []);
}), N = i(
  null,
  (s, o, { id: n, recipientDetails: t }) => {
    o(
      d,
      (r) => r.map((e) => e.id === n ? {
        ...e,
        recipient_details: t
      } : e)
    );
  }
), P = i(null, (s, o, n) => {
  o(d, (t) => t.filter((r) => r.id !== n));
}), x = i({
  currency: f,
  checkInTime: "",
  checkInEndTime: "",
  checkOutTime: "",
  checkOutEndTime: "",
  checkInInfo: "",
  showCheckInCheckOutTime: !0
}), U = i(
  null,
  (s, o, n) => {
    o(x, (t) => ({
      ...t,
      ...n
    }));
  }
), T = i({
  label: I18n.t("booking_engine.information.select_and_customise"),
  disabled: !1
}), W = i(
  null,
  (s, o, n) => {
    o(T, (t) => ({
      ...t,
      ...n
    }));
  }
), K = (s, o, n) => i(
  (t) => t(a).filter((r) => r.roomId === o ? n ? r.promotionId === s : r.pricingTypeId === s && !r.promotionId : !1).length
), L = i(
  null,
  (s, o, {
    extra: n,
    cartItemId: t,
    isOptional: r = !0
  }) => {
    o(a, (e) => {
      const c = e.find((l) => l.id === t);
      if (!c)
        return e;
      const m = r ? "optionalExtras" : "mandatoryExtras", u = c[m], I = p(u, n);
      return e.map((l) => l.id === t ? {
        ...l,
        [m]: I
      } : l);
    });
  }
), S = i(
  null,
  (s, o, n) => {
    const { cartItemId: t, personType: r, amount: e = 0 } = n;
    o(a, (c) => c.map((m) => m.id === t ? {
      ...m,
      [r]: e
    } : m));
  }
), Y = i(
  null,
  (s, o, n) => {
    const { cartItemId: t, cityTaxes: r, cityTaxIncluded: e } = n;
    o(
      a,
      (c) => c.map((m) => m.id === t ? {
        ...m,
        cityTaxes: r,
        cityTaxIncluded: e
      } : m)
    );
  }
);
export {
  w as addGiftCardToCartAtom,
  N as addRecipientDetailsToGiftCardAtom,
  R as addRoomsToCartItemsAtom,
  S as allocateGuestsAtom,
  K as amountInCartAtomCreator,
  a as cartItemsAtom,
  A as cartItemsAtomDefault,
  v as clearCartItemsAtom,
  B as clearGiftCardsAtom,
  O as giftCardCodeAtom,
  F as giftCardCurrencyAtom,
  d as giftCardsAtom,
  P as removeGiftCardFromCartAtom,
  G as removeItemFromCartItemsAtom,
  b as removeRoomFromCartItemsAtom,
  x as roomsAvailabilityAtom,
  Y as setCityTaxesToCartAtom,
  L as setExtrasToCartItemAtom,
  U as setRoomsAvailabilityAtom,
  W as setSummaryButtonAtom,
  T as summaryButtonAtom,
  D as updateRoomInCartItemsPriceAtom
};
